export interface UserViolationChartDetails {
  violationCount?: number | null;
  openCount?: number | null;
  mitigatedCount?: number | null;
  closedCount?: number | null;
  inReviewCount?: number | null;
  remediatedCount?: number | null;
}

export interface UserItem {
  userId?: number | null;
  userKey: number | null;
  userName?: string | null;
  displayName?: string | null;
  userViolationDetails?: UserViolationChartDetails;
  userViolationSummaryObjects?: {
    violationEntitlementCount?: number | null;
    violationCount?: number | null;
  };
  accountsNames?: string[];
  accountsCount?: number | null;
  riskScore?: number | null;
  systemUserName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  employeeId?: string | null;
  title?: string | null;
  department?: string | null;
  departmentName?: string | null;
  employeeType?: string | null;
  userType?: string | null;
  email?: string | null;
  status?: string | null;
  userStatus?: string | null;
  employeeClass?: string | null;
  identityType?: string | null;
  endpointName?: string | null;
  manager?: string | null;
  location?: string | null;
  customProperty1?: string | null;
  customProperty2?: string | null;
  // Dynamic role properties
  [key: string]: unknown;
}

export interface GetUsersApiResponse {
  data: UserItem[];
  status: number;
  message: string;
  displayRecords: number;
  totalRecords: number;
  page: {
    max: number;
    offset: number;
  };
  sort: {
    order: string;
    columnToSort: string;
  };
}

export interface GetUsersRequest {
  includeDetails: boolean;
  includeViolationSummary: boolean;
  displayName?: string;
  userName?: string;
  firstName?: string;
  lastName?: string;
  departmentName?: string | null;
  systemUserName?: string;
  email?: string;
  employeeId?: string | null;
  status?: string;
  globalSearch?: string | null;
  userKeys?: number[];
  entitlementKeys?: number[] | null;
  riskKeys?: number[] | null;
  displayNames?: string[];
  userNames?: string[];
  emails?: string[];
  firstNames?: string[];
  lastNames?: string[];
  departmentNames?: string[];
  statuses?: string[];
  max: number;
  offset: number;
  order: string;
  columnToSort?: string;
}

export enum UsersType {
  API_SLICE_NAME = 'aag/usersApi',
}
